var map = {
	"./en.json": [
		1189,
		102
	],
	"./es.json": [
		1190,
		103
	],
	"./widgets/en.json": [
		877,
		8
	],
	"./widgets/es.json": [
		878,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 771;
module.exports = webpackAsyncContext;